import { useEffect, useState } from "react";

/**
 * Hook to detect if the component has hydrated (moved from server to client)
 * This helps prevent hydration mismatches between server and client rendering
 *
 * @returns {boolean} true if hydrated (client-side), false if still server-side
 */
export function useHydrated() {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  return isHydrated;
}
